/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
// import { ACCEPT_TERMS, IS_TERMS_ACCEPTED, GET_ORGANIZATION, PAYMENT_GATEWAY_URL, COMPLETE_KYC } from "../pages/ProfileScreen/graphql";
// import { SUBMIT_RAZORPAY_KYC } from "../pages/KYC/graphql/razorpay-kyc.mutation";
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { humanize } from "uno-js";
// import { data } from "./config/profile-data"
// import { EDIT_PROFILE } from "../pages/ProfileScreen/graphql/edit-profile.mutation";
import {GET_MY_PROFILE,EDIT_PROFILE_DETAILS} from "../pages/Admin/graphql"
import {PROFILE_DATA} from "./test-data/profile-data";
import { toast } from "react-hot-toast"


const MODULE_NAME = "ProfileService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class ProfileService {
    private static instance: ProfileService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): ProfileService {
        if (!ProfileService.instance) {
            ProfileService.instance = new ProfileService(props);
        }
        return ProfileService.instance;
    }



    async editProfileDetails(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `EDIT Profile Details  data in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: EDIT_PROFILE_DETAILS,
                    variables: {
                        input: data
                    },

                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "EDIT Profile data: ", res);
                if (res) {
                    return res
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }

    }



    getMeta = (data: any) => {
        if (data) {
            let _output: any = [];

            for (const [key, value] of Object.entries(data)) {
                if (
                    key === "fullAddress" ||
                    key === "email" ||
                    key === "givenName" ||
                    key === "familyName" ||
                    key === "telephone" ||
                    key === "designation" ||
                    key === "forceNo" ||
                    key === "department" ||
                    key === "rank"

                ) {
                    _output.push({
                        key: humanize(key.toString()),
                        value: value ? value : "-",
                    });
                } else if (key === "sameAs") {
                    _output.push({
                        key: humanize("website"),
                        value: value ? value : "-",
                    });
                }
            }

            return _output;
        }
    };

    getButtons() {


            return [
                {
                    key: "editProfile",
                    title: "Edit",
                },
            ]
        }


    async getProfile() {
        // console.log(`profile data in services`, PROFILE_DATA);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient('graphql-gateway');
        // console.log(`profile data in services`, PROFILE_DATA);
        try {
            if (client) {
                // return PROFILE_DATA
                const res = await client.query({
                    query: GET_MY_PROFILE,
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getOrganization: ", res);
                //return res?.data?.getMyOrganization;
                return {
                    organizationData: res?.data?.getOfficerProfile,
                    paymentOption: res?.data?.getOfficerProfile?.paymentOption,
                    img: PROFILE_DATA?.img,
                    title: res?.data?.getOfficerProfile?.fullName,
                    meta: this.getMeta(res?.data?.getOfficerProfile),
                    buttons: this.getButtons()
                };
            //     // return data
            }

        } catch (err) {
            console.log(`error in getOrganization=>`, err);
        }
    }
}
